import { createGrid } from 'ag-grid-community';
import 'ag-grid-enterprise';
import { actionsColumn, sequenceSearchLink, plainText, urlRenderer, fitGridHeight } from './sequence_grid_helpers.js';

; (function () {
  "use strict";

  var SequenceSearchResults = function () {
    var initializeGrid = function () {
      var gridElement = document.querySelector('#sequenceSearchGrid');
      var dataElement = document.getElementById('sequence-search-data');

      if (!gridElement || !dataElement) return;

      var rowData = JSON.parse(dataElement.dataset.json);
      var columnDefs = [
        actionsColumn(),
        {
          headerName: 'Text Entry',
          field: 'sequence_text',
          minWidth: 180,
          flex: 1.2,
          cellRenderer: function (params) { return sequenceSearchLink(params, 'sequence_text'); }
        },
        {
          headerName: 'Creation',
          field: 'sequence_creation',
          minWidth: 150,
          flex: 1,
          cellRenderer: function (params) { return sequenceSearchLink(params, 'sequence_creation'); }
        },
        {
          headerName: 'Complete',
          field: 'sequence_complete',
          minWidth: 150,
          flex: 1,
          cellRenderer: function (params) { return sequenceSearchLink(params, 'sequence_complete'); }
        },
        {
          headerName: 'Lexigram',
          field: 'sequence_lexigram',
          minWidth: 150,
          flex: 1,
          cellRenderer: function (params) { return sequenceSearchLink(params, 'sequence_lexigram'); }
        },
        {
          headerName: 'Singular',
          field: 'sequence_singular',
          minWidth: 150,
          flex: 1,
          cellRenderer: function (params) { return sequenceSearchLink(params, 'sequence_singular'); }
        },
        {
          headerName: 'Lenses',
          field: 'sequence_lense',
          minWidth: 150,
          flex: 1,
          cellRenderer: function (params) { return sequenceSearchLink(params, 'sequence_lense'); }
        },
        {
          headerName: 'Description',
          field: 'description',
          minWidth: 240,
          flex: 1.5,
          cellRenderer: plainText
        },
        {
          headerName: 'Reference',
          field: 'reference',
          minWidth: 280,
          flex: 1.8,
          cellRenderer: plainText
        },
        {
          headerName: 'Url',
          field: 'url',
          minWidth: 220,
          flex: 1.2,
          cellRenderer: urlRenderer
        }
      ];

      fitGridHeight(gridElement, rowData.length, { rowHeight: 44, max: 680 });

      createGrid(gridElement, {
        columnDefs: columnDefs,
        rowData: rowData,
        defaultColDef: {
          resizable: true,
          sortable: true,
          filter: true,
          enableCellTextSelection: true,
          suppressMovable: true
        },
        domLayout: 'normal',
        rowHeight: 44,
        suppressFieldDotNotation: true,
        suppressMovableColumns: true,
        suppressDragLeaveHidesColumns: true,
        ensureDomOrder: true
      });
    };

    this.init = function () {
      initializeGrid();
    };
  };

  $(document).ready(function () {
    if ($('#sequenceSearchGrid').length) {
      var sequenceSearchResults = new SequenceSearchResults();
      sequenceSearchResults.init();
    }
  });
})();
